import { FC } from 'react';
import { Avatar, Box, CardHeader, Typography, useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import { PendingInvitationMember } from '../types/members-types';
import { Nullable } from 'common-types';
import DoubleActionButtonGroup from '../../common/components/DoubleActionButtonGroup';

const ResendInvitationModal: FC<
  React.PropsWithChildren<ResendInvitationModalProps>
> = props => {
  const theme = useTheme();

  const {
    open,
    onClose,
    pendingInvitationMember,
    onResend,
    onRevoke,
    isLoadingResend,
    isLoadingRevoke,
  } = props;

  if (!pendingInvitationMember) {
    return null;
  }

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Resend Invitation'
      open={open}
      onClose={onClose}
      modalHeader='Resend Invitation'>
      <Box sx={{ flexGrow: 1, mb: 2, gap: 5 }}>
        <Typography>Are you sure you want to resend invitation to</Typography>
        <CardHeader
          avatar={
            <Avatar
              alt={pendingInvitationMember.inviteeEmail}
              sx={{ width: 24, height: 24 }}
            />
          }
          title={pendingInvitationMember.inviteeEmail}
        />
      </Box>
      <DoubleActionButtonGroup
        onPrimaryClick={onResend}
        onSecondaryClick={onRevoke}
        isPrimaryLoading={isLoadingResend}
        isSecondaryLoading={isLoadingRevoke}
        primaryButtonActionLabel='Resend'
        primaryButtonActionTooltip='Resend invitation'
        primaryButtonActionColor='success'
        secondaryButtonActionLabel='Revoke'
        secondaryButtonActionTooltip='Revoke invitation'
        secondaryButtonActionColor={'error'}
        isPrimaryActionDisabled={false}
        isSecondaryActionDisabled={false}
      />
    </ModalDialog>
  );
};

interface ResendInvitationModalProps {
  open: boolean;
  pendingInvitationMember: Nullable<PendingInvitationMember>;
  onClose: () => void;
  onResend: () => void;
  onRevoke: () => void;
  isLoadingResend: boolean;
  isLoadingRevoke: boolean;
}

export default ResendInvitationModal;
